import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {MensagensService} from 'max-ng-lib';

import {SubheaderService} from '../../../../../core/services/layout/subheader.service';
import {ClienteService} from '../../../../../services/cliente.service';
import {AcessoRestritoComponent} from '../../../../layout/acesso-restrito/acesso-restrito.component';
import {Router} from '@angular/router';

@Component({
	selector: 'm-importar-localizacao-erp',
	templateUrl: './importar-localizacao-erp.component.html',
	styleUrls: ['./importar-localizacao-erp.component.scss'],
})
export class ImportarLocalizacaoErpComponent implements OnInit {
	dataImportacao: any;
	importarLocalizacaoSelecao = false;
	gerarLocalizacaoCepSelecao = false;
	importarLocalizacaoERPSexagesimal = false;
	apenasComprasUltimosSeisMeses = true;
	localizacaoEnderecoAlternativo = false;
	autorizado = false;

	constructor(
		private router: Router,
		public subheaderService: SubheaderService,
		public mensagem: MensagensService,
		public dialog: MatDialog,
		public clienteService: ClienteService
	) {
	}

	ngOnInit() {
		this.carregarSubHeaders();
		this.iniciarAcessoRestrito();

	}

	carregarSubHeaders() {
		this.subheaderService.setTitle('Importar Localização ERP');
		this.subheaderService.setBreadcrumbs([
			{
				title: 'Importar Localização ERP',
				page: '/pages/ferramentas/importar-localizacao',
			},
		]);
	}

	iniciarAcessoRestrito() {
		this.dialog.open(AcessoRestritoComponent, {
			width: '400px',
			disableClose: true,
		}).afterClosed().subscribe((result) => {
			if (result === 'authorized') {
				this.autorizado = true;
			} else {
				this.router.navigate(['/pages/paineis']);
			}
		});
	}

	importarEntregas() {
		const filtro: any = {};
		if (this.dataImportacao) {
			filtro.inicio = this.dataImportacao;
		}

		this.clienteService
			.importarDasEntregasEfetuadas(filtro)
			.subscribe((resposta) => {
				if (resposta.valido) {
					this.mensagem.exibaToastSucesso('Importado com sucesso!');
				}
			});
	}

	importarLocalizacao() {
		this.clienteService
			.importarLocalizacaoClientesERP(this.importarLocalizacaoSelecao)
			.subscribe(() =>
				this.mensagem.exibaToastSucesso('Importado com sucesso!')
			);
	}

	gerarLocalizacaoCep(gerarLocalizacaoCepSelecao: boolean = false) {

		if (!this.localizacaoEnderecoAlternativo) {

			this.clienteService
				.gerarLocalizacaoClientesPorCEP(
					gerarLocalizacaoCepSelecao,
					this.apenasComprasUltimosSeisMeses
				)
				.subscribe(() =>
					this.mensagem.exibaToastSucesso('Gerado com sucesso!')
				);
		} else {
			this.gerarEnderecoEntrega(gerarLocalizacaoCepSelecao);
		}
	}

	gerarEnderecoEntrega(gerarLocalizacaoCepSelecao: boolean = false) {
		this.clienteService
			.gerarLocalizacaoEnderecosEntrega(gerarLocalizacaoCepSelecao, this.apenasComprasUltimosSeisMeses)
			.subscribe(() =>
				this.mensagem.exibaToastSucesso('Gerado com sucesso!')
			);
	}

	gerarLocalizacaoPorCEPClientesComPedidos() {
		this.clienteService
			.gerarLocalizacaoPorCEPClientesComPedidos()
			.subscribe(() =>
				this.mensagem.exibaToastSucesso('Gerado com sucesso!')
			);
	}

	importarLocalizacaoClientesERPSexagesimal() {
		this.clienteService
			.importarLocalizacaoClientesERPSexagesimal(
				this.importarLocalizacaoERPSexagesimal
			)
			.subscribe(() =>
				this.mensagem.exibaToastSucesso('Importado com Sucesso')
			);
	}

	openAcessoRestrito() {
		if (this.gerarLocalizacaoCepSelecao) {
			const dialogRef: MatDialogRef<AcessoRestritoComponent> =
				this.dialog.open(AcessoRestritoComponent, {
					width: '400px',
					disableClose: true,
				});

			dialogRef.beforeClose().subscribe((isAuthorized: string) => {
				isAuthorized === 'authorized'
					? this.gerarLocalizacaoCep(true)
					: this.naoAutorizado();
			});
		} else {
			this.gerarLocalizacaoCep();
		}
	}

	naoAutorizado() {
		this.gerarLocalizacaoCepSelecao = false;
		this.mensagem.exibaToastAlerta(
			'Essa operação só pode ser realizada com a senha de supervisão, Por gentileza entre em contato com o suporte.'
		);
	}
}
